import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IoArrowBack, IoHome } from "react-icons/io5";

function Page404() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-primary-50 px-4">
      <div className="white-box max-w-lg w-full text-center py-12 px-8">
        {/* Big 404 */}
        <div className="relative mb-6">
          <p className="text-[8rem] font-black leading-none text-primary-100 select-none">
            404
          </p>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-6xl">🔍</span>
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-primary mb-2">
          {t("titlePages.error")}
        </h1>

        {/* Description */}
        <p className="text-slate-500 text-sm leading-relaxed mb-8">
          {t("error.text")}
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg border border-slate-200 text-primary text-sm font-medium hover:bg-slate-50 transition-colors"
          >
            <IoArrowBack className="w-4 h-4" />
            {t("error.goBack")}
          </button>
          <button
            type="button"
            onClick={() => navigate("/")}
            className="flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-primary text-white text-sm font-medium hover:bg-primary/90 transition-colors"
          >
            <IoHome className="w-4 h-4" />
            {t("error.backHome")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Page404;
